<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
    />
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="assessment_schemes"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createAssessmentScheme"
        @update="updateAssessmentScheme"
        :assessment_scheme="assessment_scheme"
        :edit="editMode"
      />
    </v-dialog>
  </div>
</template>
<script>
import formDialog from "@/components/scheme/assessmentScheme.vue";
import searchBar from "@/components/searchBar.vue";
import { assessmentSchemeHeaders } from "@/constants/headers";
export default {
  components: {
    formDialog,
    searchBar,
  },
  data() {
    return {
      headers: assessmentSchemeHeaders,
      dialog: false,
      editMode: false,
      deleteDialog: false,
      search: "",
      assessment_schemes: [],
      assessment_scheme: {},
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Assessment Schemes" }]);
    this.initialise();
  },
  methods: {
    async initialise() {
      const [assessment_schemes] = await Promise.all([
        this.$axios.get("assessment_schemes"),
      ]);
      this.assessment_schemes = assessment_schemes.data.data;
    },
    async createAssessmentScheme(data) {
      await this.$axios
        .post("assessment_schemes", { assessment_scheme: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Assessment Scheme created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateAssessmentScheme(data) {
      await this.$axios
        .put("assessment_schemes/" + data.id, { assessment_scheme: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Assessment Scheme updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    edit(item) {
      this.assessment_scheme = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.deleteDialog = false;
      this.assessment_scheme = {};
    },
  },
};
</script>

<style></style>
